import useAxios from './useAxios'
import { useQuery } from 'react-query'

const useReferenceTeam = () => {
	const { getReferenceTeam } = useAxios()
	const { isLoading, data } = useQuery('referenceTeam', getReferenceTeam)

	if (isLoading) return { isLoading }

	const { title, content } = data

	return {
		isLoading,
		title,
		content,
		list: ['2012', '2014', '2015', '2017', '2018'],
	}
}

export default useReferenceTeam
